module.exports = __webpack_public_path__ + "01_long_black.f8764998.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_long_black.png
// module id = +V6I
// module chunks = 0